jQuery(document).ready(function($) {
    // Mega Menu
    const menuButtons = $('[data-menu-id]');
    menuButtons.each(function() {
        $(this).on('click', function(e) {
            e.stopPropagation(); // Prevent the event from bubbling up

            const menuId = $(this).data('menu-id');
            const megaMenu = $('#' + menuId);
            const parentLi = $(this).closest('li');

            // Close any open mega menus
            const otherMenus = $('.mega-menu').not(megaMenu);
            otherMenus.removeClass('open');
            $('li').removeClass('menu-item-open'); // Remove the class from all <li> elements

            // Remove menu-open class if no other mega menu is open
            if (otherMenus.filter('.open').length === 0) {
                $('#wrapper-navbar').removeClass('menu-open');
            }

            // Toggle the clicked mega menu
            megaMenu.toggleClass('open');

            // Add or remove the menu-open class on the wrapper-navbar and the parent <li>
            if (megaMenu.hasClass('open')) {
                $('body').addClass('overflow-hidden');
                $('#wrapper-navbar').addClass('menu-open');
                parentLi.addClass('menu-item-open');
            } else {
                $('body').removeClass('overflow-hidden');
                $('#wrapper-navbar').removeClass('menu-open');
                parentLi.removeClass('menu-item-open');
            }
        });
    });
    $(document).on('click', function() {
        $('.mega-menu').removeClass('open');
        $('#wrapper-navbar').removeClass('menu-open');
        $('body').removeClass('overflow-hidden');
        $('li').removeClass('menu-item-open');
    });
    $('.mega-menu').on('click', function(e) {
        e.stopPropagation();
    });
    $('.closeMenuButton').on('click', function(e) {
        e.stopPropagation(); // Prevent the event from bubbling up

        const menuId = $(this).data('menu-close-button');
        const megaMenu = $('#' + menuId);
        const parentLi = megaMenu.closest('li');

        // Close the mega menu
        megaMenu.removeClass('open');
        $('#wrapper-navbar').removeClass('menu-open');
        $('body').removeClass('overflow-hidden');
        parentLi.removeClass('menu-item-open');
    });
    $('.jsMenuSearch').on('click', function (e) {
        e.stopPropagation(); // Prevent the event from bubbling up
        var $searchWrapper = $(this).next('.nav-search-wrapper');
        $('.nav-search-wrapper').not($searchWrapper).fadeOut(300); // Hide other search wrappers
        $searchWrapper.fadeToggle(300); // Toggle the current search wrapper
    });
    $(document).on('click', function () {
        $('.nav-search-wrapper').fadeOut(300); // Hide all search wrappers
    });
    $('.nav-search-wrapper').on('click', function(e) {
        e.stopPropagation();
    });


    /// Global Basic Carousel
    var basicCarousel = new Swiper(".basic-carousel", {
        effect: "fade",
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
    });
    var cardCarouselLg = new Swiper(".card-carousel-lg", {
        slidesPerView: 3,
        spaceBetween: 8,
        // keyboardControl: true,
        // mousewheel: true,
        // speed: 1000,
        slidesOffsetBefore: 65,
        freeMode: true,
        // loop:true,
        breakpoints:{
            0: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 24,
                slidesPerView:1.2,
            },
            475: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 24,
                slidesPerView:1.4,
            },
            500: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 32,
                slidesPerView:1.8,
            },
            675: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 32,
                slidesPerView:2.2,
            },
            768: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 48,
                slidesPerView:2.6,
            },
            925: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 48,
                slidesPerView:3,
            }
        }
    });

    var itineraryCarouselHome = new Swiper(".itinerary-carousel", {
        slidesPerView: 3,
        spaceBetween: 8,
        // keyboardControl: true,
        // mousewheel: true,
        // speed: 1000,
        slidesOffsetBefore: 65,
        freeMode: true,
        // loop:true,
        breakpoints:{
            0: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 24,
                slidesPerView:1.2,
            },
            475: {
                slidesOffsetBefore: 24,
                slidesPerView:1.4,
            },
            500: {
                slidesOffsetBefore: 32,
                slidesPerView:1.8,
            },
            675: {
                slidesOffsetBefore: 32,
                slidesPerView:2.2,
            },
            768: {
                slidesOffsetBefore: 24,
                slidesPerView:2.6,
            },
            925: {
                slidesOffsetBefore: 24,
                slidesPerView:3,
            }
        }
    });

    var blogCarousel = new Swiper(".blog-carousel", {
        slidesPerView: 3,
        spaceBetween: 8,
        // keyboardControl: true,
        // mousewheel: true,
        // speed: 1000,
        slidesOffsetBefore: 65,
        freeMode: true,
        // loop:true,
        breakpoints:{
            0: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 24,
                slidesPerView:1.2,
            },
            475: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 24,
                slidesPerView:1.4,
            },
            500: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 32,
                slidesPerView:1.8,
            },
            675: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 32,
                slidesPerView:1.9,
            },
            768: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 48,
                slidesPerView:2,
            },
            925: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 48,
                slidesPerView:2.2,
            },
            991: {
                slidesOffsetAfter: 24,
                slidesOffsetBefore: 48,
                slidesPerView:3,
            }
        }
    });

    var stayGallery = new Swiper(".stay-gallery", {
        lazy: true,
        navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                var totalSlides = this.slides.length;
                var currentIndex = this.realIndex || 0;
                var start = Math.floor(currentIndex / 3) * 3;
                var end = Math.min(start + 3, totalSlides); // Ensure we don't exceed the total number of slides

                // Determine if this bullet is in the current range
                if (index >= start && index < end) {
                    var activeClass = (index === currentIndex) ? ' swiper-pagination-bullet-active' : '';
                    return '<span class="' + className + activeClass + '">' + (index + 1) + "</span>";
                }
                return '';
            },
        },
        on: {
            slideChange: function () {
                var totalSlides = this.slides.length;
                var currentIndex = this.realIndex || 0;
                var previousIndex = this.previousIndex || 0;
                var currentRange = Math.floor(currentIndex / 3);
                var previousRange = Math.floor(previousIndex / 3);

                if (currentRange !== previousRange) {
                    this.pagination.el.classList.add('sliding-out');
                    setTimeout(() => {
                        this.pagination.render();
                        this.pagination.update();

                        // Manually set the active class after rendering the new set
                        var bullets = this.pagination.el.querySelectorAll('.swiper-pagination-bullet');
                        bullets.forEach(function (bullet, index) {
                            bullet.classList.toggle('swiper-pagination-bullet-active', index === currentIndex % 3);
                        });

                        this.pagination.el.classList.remove('sliding-out');
                    }, 300); // Adjust time to match the transition duration
                } else {
                    // Update the active class manually within the same range
                    var bullets = this.pagination.el.querySelectorAll('.swiper-pagination-bullet');
                    bullets.forEach(function (bullet, index) {
                        bullet.classList.toggle('swiper-pagination-bullet-active', index === currentIndex % 3);
                    });
                }
            }
        }
    });




    /// Upcoming Events --- Homepage
    $('.home-six__events > div, .event-component__events > div').hide();
    $('#this-week').show();
    // Handle button clicks
    $('.jsEventBtnSwitch').on('click', function() {
        $('.jsEventBtnSwitch').removeClass('active');
        $(this).addClass('active');
        var switchTarget = $(this).data('switch');
        $('.home-six__events > div, .event-component__events > div').hide();
        $('#' + switchTarget).fadeIn();
    });



    var ajaxURL = ajax_object.ajax_url;
    /// hotel post fetch /// hotel filters /// etc
    function fetch_hotel_posts(page = 1) {
        var filters = [];
        $('.stay-filter:checked').each(function() {
            filters.push($(this).val());
        });
        var searchQuery = $('#jsStaySearchInput').val();

        $.ajax({
            url: ajaxURL,
            type: 'POST',
            data: {
            action: 'fetch_filtered_posts',
            filters: filters,
            page: page,
            search: searchQuery
        },
        success: function (data) {
            $('#stay-posts').hide().html(data).fadeIn(500);
        }
        });
    }
    $(document).on('click', '#searchKeywords', function() {
        fetch_hotel_posts();
    });
    $(document).on('click', '.jsApplyStayFilters', function() {
        fetch_hotel_posts();
    });
    $(document).on('click', '.jsClearAllStayFilters', function() {
        $('.stay-filter').prop('checked', false);  // Uncheck all filters
        $('#jsStaySearchInput').val('')
        fetch_hotel_posts();  // Fetch posts with no filters (all posts)
    });
    $(document).on('click', '.jsStayPagination a', function(e) {
        e.preventDefault();
        var page = $(this).attr('href').split('paged=')[1];
        $('html, body').animate({
            scrollTop: $('#stay-posts').offset().top - 200
        }, 300);  // 500ms animation duration
        fetch_hotel_posts(page);  // Fetch posts for the selected page
    });







    /// event post fetch /// event filters /// etc
    function fetch_event_posts(page = 1) {
        var filters = [];
        $('.event-filter:checked').each(function() {
            filters.push($(this).val());
        });
        var searchQueryDesktop = $('.searchInputDesktop').val();
        var searchQueryMobile = $('.searchInputMobile').val();
        var selectedMonthDesktop = $('select[name="month_filter_desktop"]').val();
        var selectedYearDesktop = $('select[name="year_filter_desktop"]').val();
        var selectedMonthMobile = $('select[name="month_filter_mobile"]').val();
        var selectedYearMobile = $('select[name="year_filter_mobile"]').val();
        var selectedMonth = selectedMonthDesktop || selectedMonthMobile;
        var selectedYear = selectedYearDesktop || selectedYearMobile;
        var searchQuery = searchQueryDesktop || searchQueryMobile;
        $.ajax({
            url: ajaxURL,
            type: 'POST',
            data: {
            action: 'fetch_event_posts',
            filters: filters,
            page: page,
            search: searchQuery,
            month: selectedMonth,
            year: selectedYear,
        },
        success: function (data) {
            $('#event-posts').hide().html(data).fadeIn(500);
        }
        });
    }
    $(document).on('click', '.searchEventKeywords', function() {
        fetch_event_posts();
    });
    $(document).on('click', '.jsApplyEventFilters', function() {
        fetch_event_posts();
    });
    $(document).on('click', '.jsClearAllEventFilters', function() {
        $('.event-filter').prop('checked', false);  // Uncheck all filters
        $('#jsEventSearchInput').val('')
        $('select[name="month_filter_desktop"]').prop('selectedIndex', 0);
        $('select[name="year_filter_desktop"]').prop('selectedIndex', 0);
        $('select[name="month_filter_mobile"]').prop('selectedIndex', 0);
        $('select[name="year_filter_mobile"]').prop('selectedIndex', 0);
        fetch_event_posts();  // Fetch posts with no filters (all posts)
    });
    $(document).on('click', '.jsEventPagination a', function(e) {
        e.preventDefault();
        var page = $(this).attr('href').split('paged=')[1];
        $('html, body').animate({
            scrollTop: $('#event-posts').offset().top - 200
        }, 300);  // 500ms animation duration
        fetch_event_posts(page);  // Fetch posts for the selected page
    });







    function fetch_itin_posts(page = 1) {
        $.ajax({
            url: ajaxURL,
            type: 'POST',
            data: {
            action: 'fetch_itinerary_posts',
            page: page,
        },
        success: function (data) {
            $('#itinerary-posts').hide().html(data).fadeIn(500);
        }
        });
    }

    $(document).on('click', '.jsItineraryPagination a', function(e) {
        e.preventDefault();
        var page = $(this).attr('href').split('paged=')[1];
        $('html, body').animate({
            scrollTop: $('#itinerary-posts').offset().top - 200
        }, 300);  // 500ms animation duration
        fetch_itin_posts(page);  // Fetch posts for the selected page
    });

    function fetch_blog_posts(page = 1) {
        $.ajax({
            url: ajaxURL,
            type: 'POST',
            data: {
            action: 'fetch_blog_posts',
            page: page,
        },
        success: function (data) {
            $('#blog-posts').hide().html(data).fadeIn(500);
        }
        });
    }

    $(document).on('click', '.jsBlogPagination a', function(e) {
        e.preventDefault();
        var page = $(this).attr('href').split('paged=')[1];
        $('html, body').animate({
            scrollTop: $('#blog-posts').offset().top - 200
        }, 300);  // 500ms animation duration
        fetch_blog_posts(page);  // Fetch posts for the selected page
    });



    function stripTitle(title) {
        return title.replace(/[^a-zA-Z]+/g, "");
    }

    if (typeof google !== 'undefined' && document.getElementById('interactive-map')) {
        var map;
        var markers = [];
        var openInfoWindow = null;

        function initialize() {
            var mapOptions = {
                zoom: 14,
                center: new google.maps.LatLng(33.834722, -118.341389),
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };

            map = new google.maps.Map(document.getElementById('interactive-map'), mapOptions);

            // Create markers for all locations
            locations.forEach(function(location) {
                if (location.lat && location.lng) {
                    var lat = parseFloat(location.lat);
                    var lng = parseFloat(location.lng);

                    if (!isNaN(lat) && !isNaN(lng)) {
                        var position = new google.maps.LatLng(lat, lng);

                        var marker = new google.maps.Marker({
                            position: position,
                            map: map,
                            icon: location.icon,
                            title: location.title,
                            strippedTitle: stripTitle(location.title), // Store stripped title on marker
                            group: location.group
                        });
                        var tagsHtml = '';
                        if (location.tags && location.tags.length > 0) {
                            location.tags.forEach(function(tag) {
                                // Map tags to their respective image paths
                                var imgSrc = '';
                                switch(tag.name) {
                                    case 'Spas':
                                        imgSrc = '/wp-content/themes/discover-torrance/assets/img/spas-side-icon.png';
                                        break;
                                    case 'Parks':
                                        imgSrc = '/wp-content/themes/discover-torrance/assets/img/parks-side-icon.png';
                                        break;
                                    case 'Meetings':
                                        imgSrc = '/wp-content/themes/discover-torrance/assets/img/meetings-side-icon.png';
                                        break;
                                    case 'Museums':
                                        imgSrc = '/wp-content/themes/discover-torrance/assets/img/museums-side-icon.png';
                                        break;
                                    case 'Hotels':
                                        imgSrc = '/wp-content/themes/discover-torrance/assets/img/hotels-side-icon.png';
                                        break;
                                    case 'Breweries':
                                        imgSrc = '/wp-content/themes/discover-torrance/assets/img/breweries-side-icon.png';
                                        break;
                                    case 'Shopping':
                                        imgSrc = '/wp-content/themes/discover-torrance/assets/img/shop-side-icon.png';
                                        break;
                                    case 'Restaurants':
                                        imgSrc = '/wp-content/themes/discover-torrance/assets/img/restaurants-side-icon.png';
                                        break;
                                    default:
                                        imgSrc = ''; // No image for unknown tags
                                }

                                // Add the image and tag name to the HTML if an image is found
                                if (imgSrc) {
                                    tagsHtml += ` <img src="${imgSrc}" class="pop-img" width="30" alt="${tag.name}" />`;
                                }
                            });
                        }

                        var contentString = `
                            <div class="infoWindowPopUp pb-32">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <img src="${location.image}" class="img-fluid h-100 w-100" style="max-width:100%!important;object-fit:cover;">
                                        </div>
                                        <div class="col-lg-6">
                                            <div class="info">
                                                <strong class="title">${location.title}</strong>
                                                <div class="address mt-16">
                                                    <strong>Address: </strong>
                                                    ${location.address}
                                                </div>
                                                <div class="phone my-8">
                                                    <strong>Phone: </strong>
                                                    ${location.phone}
                                                </div>
                                                <div class="mt-16 d-flex gap-12 align-items-center">
                                                    <a href="${location.url}" class="btn btn-primary">
                                                        Learn More
                                                    </a>
                                                    ${tagsHtml ? `
                                                    <div class="tags d-flex gap-12">
                                                        ${tagsHtml}
                                                    </div>` : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                        // var contentString = '<div class="gomapMarkerInside">' +
                        //     '<div class="marker-left" style="background-image:url(' + location.image + ');">' +
                        //     '<img src="' + location.image + '" />' +
                        //     '</div><div class="marker-right">' +
                        //     '<div class="marker-right-title">' + location.title + '</div>' +
                        //     (location.address ? '<div class="row"><span class="listing-info-item-title">Address: </span><span>' + location.address + '</span></div>' : '') +
                        //     (location.phone ? '<div class="row"><span class="listing-info-item-title">Phone: </span><span>' + location.phone + '</span></div>' : '') +
                        //     '<div class="row map-more"><a href="' + location.url + '" class="home-more">Learn More</a>' +
                        //     '</div></div></div>';

                        var infowindow = new google.maps.InfoWindow({
                            content: contentString
                        });

                        marker.infowindow = infowindow; // Attach the infowindow to the marker

                        marker.addListener('click', function() {
                            if (openInfoWindow) {
                                openInfoWindow.close();
                            }
                            infowindow.open(map, marker);
                            openInfoWindow = infowindow;
                        });

                        markers.push(marker); // Store the marker in the array
                    }
                }
            });

            $('#mapFilterForm input[name="map-filter"]').on('change', function() {
                filterMarkers();
            });

            applyFiltersFromUrl(); // Apply filters and open specific listing if specified

            $('.jsClearMapFilters').on('click', function(event) {
                event.preventDefault();
                $('#mapFilterForm input[name="map-filter"]').prop('checked', false);
                $('#mapFilterForm input[value="Hotels"]').prop('checked', true);
                filterMarkers();
            });

            filterMarkers(); // Initial call to display markers based on default filter
        }

        function filterMarkers() {
            var selectedFilters = [];
            var bounds = new google.maps.LatLngBounds();

            $('#mapFilterForm input[name="map-filter"]:checked').each(function() {
                selectedFilters.push($(this).val());
            });

            var markersVisible = false;

            markers.forEach(function(marker) {
                if (selectedFilters.includes(marker.group) || !selectedFilters.length) {
                    marker.setMap(map);
                    bounds.extend(marker.getPosition());
                    markersVisible = true;
                } else {
                    marker.setMap(null);
                }
            });

            if (markersVisible) {
                map.fitBounds(bounds);
            } else {
                map.setCenter(new google.maps.LatLng(33.834722, -118.341389));
                map.setZoom(14);
            }
        }

        function getQueryParams() {
            var params = {};
            window.location.search.substring(1).split('&').forEach(function(pair) {
                var keyValue = pair.split('=');
                if (keyValue.length === 2) {
                    params[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
                }
            });
            return params;
        }

        function applyFiltersFromUrl() {
            var params = getQueryParams();
            var targetMarker = null;

            // Clear all filters by default
            $('#mapFilterForm input[name="map-filter"]').prop('checked', false);

            // Apply filter from query parameter
            if (params.filter) {
                var filters = params.filter.split(',');
                filters.forEach(function(filter) {
                    $('#mapFilterForm input[value="' + filter + '"]').prop('checked', true);
                });
            }

            // Find the marker by the stripped title from the showListing parameter
            if (params.showListing) {
                markers.forEach(function(marker) {
                    if (marker.strippedTitle === params.showListing) {
                        targetMarker = marker;
                        return false; // Break the loop when the marker is found
                    }
                });
            }

            // Apply the filters and focus on the target marker if available
            filterMarkers();

            if (targetMarker) {
                targetMarker.infowindow.open(map, targetMarker);
                map.setCenter(targetMarker.getPosition());
                map.setZoom(16); // Zoom in closer to the selected marker
                openInfoWindow = targetMarker.infowindow; // Set the opened info window
            }
        }

        google.maps.event.addDomListener(window, 'load', initialize);
    }




    function fetch_listing_posts(page = 1, keyword = '') {
        $.ajax({
            url: ajaxURL,
            type: 'POST',
            data: {
                action: 'fetch_listing_posts',
                page: page,
                postType: postType,
                keyword: keyword
            },
        success: function (data) {
            $('#listingPosts').hide().html(data).fadeIn(500);
        }
        });
    }
    $('#searchKeywordsListing').on('click', function() {
        var keyword = $('#jsListingSearchInput').val(); // Get the keyword from the input
        fetch_listing_posts(1, keyword); // Fetch posts based on the keyword
    });
    $('#clearKeywordSearch').on('click', function() {
        $('#jsStaySearchInput').val(''); // Clear the input field
        fetch_listing_posts(1, ''); // Fetch posts without any keyword (reset to default)
    });

    $(document).on('click', '.jsListingPagination a', function(e) {
        e.preventDefault();
        var page = $(this).attr('href').split('paged=')[1];
        var keyword = $('#jsStaySearchInput').val(); // Maintain the search keyword during pagination
        $('html, body').animate({
            scrollTop: $('#listingPosts').offset().top - 200
        }, 300);  // 500ms animation duration
        fetch_listing_posts(page, keyword);  // Fetch posts for the selected page
    });

    $('.menuToggle').on('click', function(event) {
        let expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);
        $('#mobileMenu').slideToggle();
        event.preventDefault();
    });



    function fetch_search_posts(page = 1, keyword = '') {
        $.ajax({
            url: ajaxURL,
            type: 'POST',
            data: {
                action: 'fetch_search_results',
                page: page,
                postType: 'post', // Assuming you're searching through posts
                keyword: keyword
            },
            success: function (data) {
                $('#searchResults').hide().html(data).fadeIn(500);
            }
        });
    }

    $(document).on('click', '.jsSearchPagination a', function(e) {
        e.preventDefault();
        var page = $(this).attr('href').split('paged=')[1];
        var keyword = $('.jsSearchInput').val();
        $('html, body').animate({
            scrollTop: $('#searchResults').offset().top - 200
        }, 300);  // 300ms animation duration
        fetch_search_posts(page, keyword);  // Fetch posts for the selected page
    });


    function fetch_restaurant_posts(page = 1) {
        var filters = [];
        $('.restaurants-filter:checked').each(function() {
            filters.push($(this).val());
        });
        var searchQuery = $('#jsRestaurantsSearchInput').val();

        $.ajax({
            url: ajaxURL,
            type: 'POST',
            data: {
            action: 'fetch_restaurant_posts',
            filters: filters,
            page: page,
            search: searchQuery
        },
        success: function (data) {
            $('#restaurants-posts').hide().html(data).fadeIn(500);
        }
        });
    }
    $(document).on('click', '#searchKeywordsRest', function() {
        fetch_restaurant_posts();
    });
    $(document).on('click', '.jsApplyRestFilters', function() {
        fetch_restaurant_posts();
    });
    $(document).on('click', '.jsClearAllRestFilters', function() {
        $('.restaurants-filter').prop('checked', false);  // Uncheck all filters
        $('#jsRestaurantsSearchInput').val('')
        fetch_restaurant_posts();  // Fetch posts with no filters (all posts)
    });
    $(document).on('click', '.jsRestPagination a', function(e) {
        e.preventDefault();
        var page = $(this).attr('href').split('paged=')[1];
        $('html, body').animate({
            scrollTop: $('#restaurants-posts').offset().top - 200
        }, 300);  // 500ms animation duration
        fetch_restaurant_posts(page);  // Fetch posts for the selected page
    });



    $('#filterCollapseBtn').on('click',function(e){
        e.preventDefault();
        $(this).toggleClass('open');
        $('#filterCollapse').toggleClass('show');
    });




});

